<script setup>
import AppHead from '@/Components/AppHead.vue'
import DefaultFooter from '@/Components/DefaultFooter.vue'
import DefaultHeader from '@/Components/DefaultHeader.vue'
import GetInTouchModal from '@/Components/GetInTouchModal.vue'
import SupportEnquiryModal from '@/Components/SupportEnquiryModal.vue'
import StickyHeader from '@/Components/sticky-headers/StickyHeader.vue'
import { useAnnouncementSchedule } from '@/Composables/useAnnouncements.js'

const { showAnnouncement } = useAnnouncementSchedule()
</script>

<template>
	<AppHead />

	<section class="is-nav-transparent is-offset-up-nav is-idrive-rentals">
		<div
			class="bg-pattern bg-idrive-dark w-full h-dvh md:h-[500px] absolute top-0 left-0 z-0"
		/>

		<StickyHeader v-if="showAnnouncement" />

		<DefaultHeader />

		<slot />

		<DefaultFooter />

		<GetInTouchModal />

		<SupportEnquiryModal />
	</section>
</template>
